import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNotice(code, defaultValue) {
  const queryKey = ['notices', code, defaultValue];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (code === 'new') {
        return defaultValue;
      }

      return platformApi.get(`notices/${code}`, { signal }).json();
    },
    enabled: !!code,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
